/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

export const PATHS = {
  TODOLIST: {
    CATEGORY: {
      path: '/todo-list/:category?',
    },
    CATEGORY_OBJECT: {
      name: 'toDoList',
      path: '/todo-list/:category/:objectType?',
    },
  },
  SOR: {
    LISTING: {
      path: '/sor/listing',
    },
    LISTING_OBJECT: {
      name: 'sorListingPage',
      path: '/sor/listing/:objectTypeRaw',
    },
  },
  PROGRAM_SCOPING: {
    PROGRAM: {
      name: 'programScoping',
      path: '/program-scoping',
    },
    PROGRAM_OBJECT: {
      name: 'programScopingPSSOScoping',
      path: '/program-scoping/:programId/:objectType',
    },
  },
  PROFILE: {
    name: 'userProfilePage',
    path: '/profile',
  },
  SETTINGS: {
    PEOPLE_ROLES: {
      name: 'peopleRolesSettings',
      path: '/settings/people/*',
    },
    EMAIL: {
      name: 'emailSettings',
      path: '/settings/email_settings',
    },
    ZENCONNECT: {
      name: 'connectorsSettings',
      path: '/settings/connectors',
    },
    SAML: {
      name: 'samlSettings',
      path: '/settings/saml_settings',
    },
    SAML_SAVE: {
      name: 'samlSettings/save',
      path: 'save',
    },
    INTEGRATIONS: {
      name: 'integrationSettings',
      path: '/settings/integrations/:integrationName',
    },
    RISK: {
      name: 'riskSettings',
      path: '/settings/risk/:tab?',
    },
    AUTHENTICATION: {
      name: 'authenticationSettings',
      path: '/settings/authentication',
    },
    AUTHENTICATION_SAML: {
      name: 'authenticationSettingsSaml',
      path: '/settings/authentication/saml/:tab?',
    },
    SERVICENOW: {
      SETTINGS: {
        name: 'servicenowSettings',
        path: '/settings/servicenow',
      },
      STEP1: {
        name: 'servicenowStep1Settings',
        path: '/settings/servicenow/connect',
      },
    },
    SYSTEM: {
      name: 'systemSettings',
      path: '/settings/system_settings',
    },
    STORAGE: {
      INTEGRATION: {
        name: 'storageIntegrationSettings',
        path: '/storage/integrations',
      },
    },
    CUSTOM_ATTRIBUTES: {
      name: 'customAttributesSettings',
      path: '/settings/custom_attributes',
    },
  },
  SURVEY: {
    BUILDER: {
      name: 'surveyBuilder',
      path: '/survey_builder/:surveyId',
    },
    SENDING: {
      name: 'surveySending',
      path: '/survey_sending/new/:objectType/:objectId',
    },
    RESENDING: {
      name: 'surveyResending',
      path: '/survey_sending/resend/:publicId',
    },
  },
  AUDIT: {
    LIST: {
      name: 'auditList',
      path: '/reports/audits/*',
    },
    WIZARD: {
      name: 'auditSetupWizard',
      path: '/reports/audits/wizard',
    },
    NEW: {
      name: 'auditSetupWizard/new',
      path: 'new',
    },
    EDIT: {
      name: 'auditSetupWizard/edit',
      path: 'edit/:auditId/:step?',
    },
  },
  COMPLIANCE: {
    DASHBOARD: {
      name: 'complianceDashboard',
      path: '/reports/compliance_dashboard',
    },
  },
  IMPORT: {
    name: 'import',
    path: '/import',
  },
  EXPORT: {
    name: 'export',
    path: '/export/:configId?',
  },
  RISK_HEATMAP: {
    name: 'riskHeatmap',
    path: '/risk_heatmap',
  },
  WATCH_UNSUBSCRIBE: {
    name: 'watchUnsubscribe',
    path: '/watch/unsubscribe/:obj_type/:id',
  },
  NEW_OBJECT: {
    name: 'newObject',
    path: '/new-object/:objectType',
  },
  DASHBOARD: {
    EMBEDDED: {
      path: '/dashboards/embedded',
    },
    LIST: {
      path: '/dashboards',
    },
    NEW: {
      path: '/dashboards/new',
    },
    ITEM: {
      path: '/dashboards/:dashboardId',
    },
  },
  OBJECT_MAPPER: {
    name: 'objectMapper',
    path: '/object_mapper/:leftType/:objectIds/:rightType?',
  },
  NOT_FOUND: {
    name: 'error404',
    path: '*',
  },
  WORKFLOWS: {
    name: 'workflows',
    path: '/workflows',
  },
  BENCHMARKS: {
    name: 'benchmarks',
    path: '/benchmarks',
  },
  BENCHMARK: {
    name: 'benchmark',
    path: '/benchmarks/:benchmarkId',
  },
  RISK_ALLOCATION: {
    name: 'risk-allocation',
    path: '/risk-allocation',
  },
  DEVELOPERS: {
    name: 'developers',
    path: '/developers',
  },
};
